export type RoleOverviewRole = 'project_manager' | 'admin' | 'finance' | 'hr'

export type RoleOverviewAppKey =
  | 'project_management'
  | 'time_tracking'
  | 'tasks'
  | 'files'
  | 'compliance_center'
  | 'my_organization'
  | 'accounting'
  | 'hr'

export type RoleOverviewItemTranslationKey =
  | 'define_r_and_d_projects_and_work_packages'
  | 'build_the_personnel_and_effort_plan'
  | 'resolve_overbookings_before_lock'
  | 'log_research_hours'
  | 'review_and_approve_timesheets'
  | 'keep_effort_matching_the_plan'
  | 'break_work_into_to_dos'
  | 'assign_owners_and_track_progress'
  | 'link_tasks_to_work_packages'
  | 'upload_supporting_documents'
  | 'organize_by_year_and_project'
  | 'share_with_the_right_people'
  | 'approve_application_steps'
  | 'handle_bsfz_inquiries'
  | 'drive_year_end_close_and_file_with_elster'
  | 'complete_base_data_and_tax_credentials'
  | 'keep_revenue_and_cost_figures_current'
  | 'confirm_the_financial_framework'
  | 'upload_payrolls_timesheets_and_employee_data'
  | 'categorize_uploaded_documents'
  | 'maintain_company_and_important_data'
  | 'keep_financial_figures_current'
  | 'manage_tax_and_elster_access'
  | 'maintain_the_ledger'
  | 'track_invoices_and_costs'
  | 'reconcile_r_and_d_expenses'
  | 'upload_and_categorize_documents'
  | 'work_through_the_application_steps'
  | 'respond_to_bsfz_inquiries'
  | 'keep_employee_records'
  | 'track_contracts_and_absences'
  | 'provide_payroll_and_people_data'

export interface RoleOverviewSourceItem {
  translationKey: RoleOverviewItemTranslationKey
  category?: string
  priority?: number
}

interface RoleOverviewSourceApp {
  key: RoleOverviewAppKey
  items: RoleOverviewSourceItem[]
}

export type RoleOverviewSourceData = Record<
  RoleOverviewRole,
  RoleOverviewSourceApp[]
>

export type RoleOverviewApp = RoleOverviewSourceApp

export interface RoleOverviewScreenProps {
  roles: RoleOverviewRole[]
  userName: string
  onComplete: () => void
}
